import React from "react";
import { Drawer, IconButton, Typography } from "@mui/material";
import { X } from "lucide-react";
import Button from "./ui/Button";

export interface DrawerFormProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  error?: string | null;
  footerLeft?: React.ReactNode;
  footerRight?: React.ReactNode;
  width?: number | string; // e.g. '34vw'
  // Optional standardized actions rendered as Buttons when footerRight is not provided
  primaryAction?: { label: string; onClick: () => void; disabled?: boolean };
  secondaryAction?: { label: string; onClick: () => void; disabled?: boolean };
}

export default function DrawerForm(props: DrawerFormProps) {
  const { open, title, onClose, children, error, footerLeft, footerRight, width = '34vw', primaryAction, secondaryAction } = props;
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDrawer-paper': { width, minWidth: 360, maxWidth: 560, boxSizing: 'border-box' } }}
    >
      <div className="h-full flex flex-col bg-white">
        <div className="bg-[#E3F2FD] h-1"></div>
        <div className="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-200">
          <Typography variant="h5" className="font-semibold text-gray-900">
            {title}
          </Typography>
          <IconButton onClick={onClose} className="text-gray-500 hover:text-gray-700">
            <X className="h-5 w-5" />
          </IconButton>
        </div>

        <div className="flex-1 overflow-auto p-5 space-y-6">
          {children}
        </div>

        <div className="border-t border-gray-200 p-4 flex items-center justify-between gap-3 bg-white">
          <div className="text-red-600 text-xs">{footerLeft ?? (error || null)}</div>
          <div className="flex items-center gap-2">
            {footerRight ?? (
              <>
                {secondaryAction && (
                  <Button variant="secondary" onClick={secondaryAction.onClick} disabled={secondaryAction.disabled}>{secondaryAction.label}</Button>
                )}
                {primaryAction && (
                  <Button onClick={primaryAction.onClick} disabled={primaryAction.disabled}>{primaryAction.label}</Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </Drawer>
  );
}


